
class Checkout {
  constructor() {
    this.checkoutForm = document.querySelector('.js-checkout-form');
    if (this.checkoutForm) {
      this.radioButtons = [...document.querySelectorAll('input[name="login"]')];
      this.submitBtn = document.querySelector('.js-submit');
      this.requiredInput = this.checkoutForm.querySelector('.js-required-input');
      this.requiredMessage = this.checkoutForm.querySelector('.js-required-message');
      const DOBlabel = document.querySelector('label[for="id_date_of_birth_0"]');
      if (!DOBlabel) return;
      this.dateOfBirth = document.querySelector('label[for="id_date_of_birth_0"]').parentNode;
      if (this.radioButtons.filter(input => input.checked && input.value === 'register').length > 0) {
        this.markDateOfBirthRequired();
      } else {
        this.markDateOfBirthUnrequired();
      }
      this.bindEvents();
    }
  }

  bindEvents() {
    // Prevent native browser error messages
    this.requiredInput.addEventListener('invalid', event => {
      event.preventDefault();
    });

    // Prevent form submission
    this.checkoutForm.addEventListener('submit', event => {
      event.preventDefault();
    });

    this.radioButtons.map(radio => {
      radio.addEventListener('change', (eventObj) => {
        if (eventObj.currentTarget.value === 'register') {
          this.markDateOfBirthRequired();
        } else {
          this.markDateOfBirthUnrequired();
        }
      });
    });
    this.submitBtn.addEventListener('click', () => {
      if (this.requiredInput.checked) {
        this.submitBtn.setAttribute('disabled', true);
        this.submitBtn.classList.add('loading');
        this.checkoutForm.submit();
      } else {
        this.requiredMessage.classList.remove('is-hidden');
      }
    });
  }

  markDateOfBirthRequired() {
    this.dateOfBirth.classList.add('is-required');
    this.dateOfBirth.classList.remove('is-hidden');
  }

  markDateOfBirthUnrequired() {
    this.dateOfBirth.classList.remove('is-required');
    this.dateOfBirth.classList.add('is-hidden');
  }
}

export default new Checkout();



// WEBPACK FOOTER //
// ./src/js/checkout.js